<template>
    <div>
        <a :href="entraLink">
            <button class="btn btn-block btn-entra d-flex align-items-center" @click="loginWithEntra" :disabled="busy">

                <svg style="height: 20px" class="mr-2"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#fff" d="M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"/></svg>
                <span v-if="loginWithEntraPending">
                        Logowanie<blinking-dots/>
                    </span>
                <span v-else>Zaloguj się przez Microsoft Entra</span>
            </button>
        </a>

        <a :href="googleLink">
            <button class="btn btn-block btn-google d-flex align-items-center" @click="loginWithGoogle" :disabled="busy">
                <svg style="height: 20px" class="mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#fff" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"/></svg>
                <span v-if="loginWithGooglePending">
                    Logowanie<blinking-dots/>
                </span>
                <span v-else>Zaloguj się przez Google</span>
            </button>
        </a>
    </div>
</template>

<script>
import BlinkingDots from "@/modules/Auth/components/BlinkingDots.vue";

export default {
    name: "ExternalLogins",
    components: {BlinkingDots},

    data() {
        return {
            loginWithEntraPending: false,
            loginWithGooglePending: false,
        };
    },

    computed: {
        entraLink() {
            return `${process.env.VUE_APP_DX_URL}/external-oauth/connect/azure`;
        },

        googleLink() {
            return `${process.env.VUE_APP_DX_URL}/external-oauth/connect/google`;
        },

        busy() {
            return this.loginWithEntraPending || this.loginWithGooglePending;
        }
    },

    methods: {
        loginWithEntra() {
            this.loginWithEntraPending = true;
        },

        loginWithGoogle() {
            this.loginWithGooglePending = true;
        }
    }
}
</script>

<style scoped>
.btn-entra {
    background-color: #0078D4;
    color: white;
    border: none;
    padding: 10px;
    margin: 10px 0;
}

.btn-google {
    background-color: #DB4437;
    color: white;
    border: none;
    padding: 10px;
    margin: 10px 0;
}
</style>